import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7186f7cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail-topic-lottie",
  "aria-hidden": true
}

import { computed } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';

/**
 * Topic-matched Lottie illustration for detail "Thông tin" / "Chi tiết" sections.
 * Assets live in public/media/lottie (free LottieFiles community animations).
 * Renders full width of its column, centered, to maximize visible content.
 */
export type DetailLottieTopic =
  | 'hop-dong'
  | 'bien-ban'
  | 'kho'
  | 'phieu-nhap'
  | 'phieu-xuat'
  | 'danh-muc-vat-tu'
  | 'danh-muc-toa-xe'
  | 'dinh-muc'
  | 'ke-hoach-sua-chua';

const LOTTIE_ASSET_VERSION = '20260729b';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailTopicLottie',
  props: {
    topic: {},
    height: { default: '100%' },
    width: { default: '100%' }
  },
  setup(__props: any) {

const TOPIC_FILE: Record<DetailLottieTopic, string> = {
  'hop-dong': 'hop-dong.json',
  'bien-ban': 'bien-ban.json',
  kho: 'kho.json',
  'phieu-nhap': 'phieu-nhap.json',
  'phieu-xuat': 'phieu-xuat.json',
  'danh-muc-vat-tu': 'danh-muc-vat-tu.json',
  'danh-muc-toa-xe': 'danh-muc-toa-xe.json',
  'dinh-muc': 'dinh-muc.json',
  'ke-hoach-sua-chua': 'ke-hoach-sua-chua.json',
};

/** Bump when replacing public/media/lottie assets so browsers skip stale cache. */
const props = __props;

const animationPath = computed(
  () => `/media/lottie/${TOPIC_FILE[props.topic]}?v=${LOTTIE_ASSET_VERSION}`,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (animationPath.value)
      ? (_openBlock(), _createBlock(_unref(Vue3Lottie), {
          key: 0,
          "animation-link": animationPath.value,
          height: _ctx.height,
          width: _ctx.width,
          loop: true,
          "auto-play": true
        }, null, 8, ["animation-link", "height", "width"]))
      : _createCommentVNode("", true)
  ]))
}
}

})